<template>
  <div class="delete-account">
    <base-icon
      class="modal-icon"
      size="normal"
      name="warning"
    />
    <h2
      class="delete-account__title"
    >
      {{ $t('userAccount.cancelModal.title') }}
    </h2>
    <p
      class="delete-account__description"
      v-html="description"
    />
    <div
      v-if="!oneTimePayment"
      class="delete-account__check"
    >
      <div
        data-testid="checkbox"
        @click="toggleCheck"
      >
        <BaseCheckBox
          size="big"
          :is-checked="isChecked"
        />
      </div>
      {{ checkboxLabel }}
    </div>
    <div class="delete-account__actions">
      <button
        class="delete-account__button delete-account__cancel"
        data-testid="cancel-button"
        @click="closeModal"
      >
        {{ $t('userAccount.cancelModal.close') }}
      </button>
      <button
        class="delete-account__button delete-account__accept"
        :class="{ 'delete-account__button--disabled': isButtonDisabled}"
        data-testid="confirm-button"
        @click="actionModal"
        v-html="confirmCTA"
      />
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
    components: {
        BaseIcon: () =>
            import(/* webpackChunkName: "BaseIcon"*/ '@RepoComponent/BaseIcon/BaseIcon'),
        BaseCheckBox: () =>
            import(/* webpackChunkName: "BaseCheckBox"*/ '@RepoComponent/BaseCheckBox/BaseCheckBox'),
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        subscription : {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isChecked: false,
            oneTimePayment: false,
            confirmCTA: this.$t('userAccount.cancelModal.cta'),
            description: this.$t('userAccount.cancelModal.free-license-text'),
            checkboxLabel: this.$t('userAccount.cancelModal.checkbox'),
        };
    },
    computed: {
        isButtonDisabled() {
            return this.isLoading || (!this.isChecked && !this.oneTimePayment);
        },
    },
    beforeMount() {
        const {dueDate, isSubscribed, subscriptionType, typeLicense} = this.subscription;

        this.oneTimePayment = isSubscribed && typeLicense === 'oneTimePayment';

        if (this.oneTimePayment) {
            this.confirmCTA = this.$t('userAccount.cancelModal.ot-license-cta');
            this.description = this.$t('userAccount.cancelModal.ot-license-text');
        }

        const currentDate = DateTime.now().toISO();

        if ((!isSubscribed && subscriptionType === 'pro' && dueDate > currentDate && typeLicense === 'subscription')) {
            this.description = this.$t('userAccount.cancelModal.subscription-text');
            this.checkboxLabel = this.$t('userAccount.cancelModal.subscription-checkbox');
        }
    },
    methods: {
        toggleCheck(event) {
            event.preventDefault();
            this.isChecked = !this.isChecked;
        },
        closeModal() {
            this.$emit('close');
        },
        actionModal() {
            if (this.isButtonDisabled) {
                return;
            }
            this.$emit('action');
        },
    },
};
</script>

<style src="./DeleteAccountConfirmComponent.scss" lang="scss" />